/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * The kind of content.
 */
export const WorkloadPlatformBlockType = {
  Text: "text",
  Image: "image",
  Link: "link",
  Field: "field",
  SubjectRule: "subject_rule",
  AgentPicker: "agent_picker",
  Tags: "tags",
  ComputedStatus: "computed_status",
  Computed: "computed",
  ChecklistItem: "checklist_item",
} as const;
/**
 * The kind of content.
 */
export type WorkloadPlatformBlockType = ClosedEnum<
  typeof WorkloadPlatformBlockType
>;

/**
 * The value a computed block or checklist item shows.
 */
export const Value = {
  Unknown: "",
  TokenEndpoint: "token_endpoint",
  IssuerUrl: "issuer_url",
  McpHost: "mcp_host",
} as const;
/**
 * The value a computed block or checklist item shows.
 */
export type Value = ClosedEnum<typeof Value>;

/**
 * One piece of a guided setup step. Which fields are set depends on type; the rest are empty.
 */
export type WorkloadPlatformBlock = {
  /**
   * An image's alternative text.
   */
  alt: string;
  /**
   * Shown under an image.
   */
  caption: string;
  /**
   * Shown under a computed value or checklist item.
   */
  help: string;
  /**
   * A link's https target.
   */
  href: string;
  /**
   * A link's or computed value's label, or the console field or control a checklist item names.
   */
  label: string;
  /**
   * A text block's Markdown, or what a checklist item without a value asks the operator to do. Raw HTML in it must not be rendered.
   */
  markdown: string;
  /**
   * An image's path on the dashboard's origin.
   */
  src: string;
  /**
   * The kind of content.
   */
  type: WorkloadPlatformBlockType;
  /**
   * The value a computed block or checklist item shows.
   */
  value: Value;
  /**
   * The variable key a field collects.
   */
  variable: string;
};

/** @internal */
export const WorkloadPlatformBlockType$inboundSchema: z.ZodMiniEnum<
  typeof WorkloadPlatformBlockType
> = z.enum(WorkloadPlatformBlockType);

/** @internal */
export const Value$inboundSchema: z.ZodMiniEnum<typeof Value> = z.enum(Value);

/** @internal */
export const WorkloadPlatformBlock$inboundSchema: z.ZodMiniType<
  WorkloadPlatformBlock,
  unknown
> = z.object({
  alt: z.string(),
  caption: z.string(),
  help: z.string(),
  href: z.string(),
  label: z.string(),
  markdown: z.string(),
  src: z.string(),
  type: WorkloadPlatformBlockType$inboundSchema,
  value: Value$inboundSchema,
  variable: z.string(),
});

export function workloadPlatformBlockFromJSON(
  jsonString: string,
): SafeParseResult<WorkloadPlatformBlock, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => WorkloadPlatformBlock$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'WorkloadPlatformBlock' from JSON`,
  );
}
